import React from 'react'

export const ContentModeContext = React.createContext<{ isSimplified: boolean; wordLength?: number }>({
  isSimplified: false,
})
